import { render, staticRenderFns } from "./CustomerViewInfoCardPartTwo.vue?vue&type=template&id=2b4c6979&scoped=true"
import script from "./CustomerViewInfoCardPartTwo.vue?vue&type=script&lang=js"
export * from "./CustomerViewInfoCardPartTwo.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewInfoCardPartTwo.vue?vue&type=style&index=0&id=2b4c6979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c6979",
  null
  
)

export default component.exports